import React from 'react';
import './styles.scss';
export interface Props {
  name: string;
  barcode: string;
  puckType: string;
  pinCount: number;
  available: number;
  onPuckCardClickHandler: () => void;
}

const Puck = (props: Props) => {
  const { name, barcode, puckType, pinCount, available, onPuckCardClickHandler } = props;

  return (
    <div
      id="cardtemplates-puck-wrapper"
      className={
        available ? 'puck-dewar-card-available-style' : 'puck-dewar-card-disabled-style'
      }
      onClick={available ? onPuckCardClickHandler : null}
    >
      <div id="cardtemplates-puck-header" className="flex flex-row">
        <div
          id="cardtemplates-puck-name"
          className="w-2/5 text-[#474747] text-base font-normal"
        >
          {name}
        </div>
        <div
          id="cardtemplates-puck-barcode"
          className="w-3/5 text-[#474747] text-base font-normal"
        >
          {barcode}
        </div>
      </div>
      <div id="cardtemplates-puck-details" className="flex flex-row w-full">
        <div
          id="cardtemplates-puck-type"
          className="w-2/5 text-[#313131] text-base font-normal"
        >
          {puckType}
        </div>
        <div id="cardtemplates-puck-sub-details" className="flex flex-row w-3/5">
          <div
            id="cardtemplates-puck-pin-count"
            className="w-1/2 text-[#313131] text-base font-semibold"
          >{`Pin Count: ${pinCount}`}</div>
          <div
            id="cardtemplates-puck-available"
            className="w-1/2 text-[#313131] text-base font-semibold"
          >{`Available: ${available}`}</div>
        </div>
      </div>
    </div>
  );
};

export default Puck;
